import { z } from 'zod'

export const importReservationSchema = z.object({
  email: z.string().min(1, 'Ce champ est requis').email('Veuillez saisir une adresse email valide'),
  lastName: z.string().min(1, 'Ce champ est requis'),
  dossierNumber: z.string().min(1, 'Ce champ est requis'),
})

export type ImportReservationSchema = z.infer<typeof importReservationSchema>
